import React, { PureComponent } from 'react';
import { withRouter } from '../WithRouterHOC';
import { connect } from 'react-redux';
import * as Map from 'immutable';
import { Modal, Popover, Tooltip, message } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import Util from '../../script/util';
import DsUserBasicInfo from './dsUserBasicInfo/DsUserBasicInfo';
import DsUserSkillInfo from './dsUserSkillInfo/DsUserSkillInfo';
import DsUserAchieve from './dsUserAchieve/DsUserAchieve';
import './DsMainNew.scss';
import JoinTalk from './joinTalk/JoinTalk';
import {
  _change_remark_modal,
  _change_ds_modal,
  _dssp_send_click,
  _new_nim_window,
  _new_room_window,
  _show_login_modal,
  _get_user_affinity_info,
  _dssp_show_event,
} from '../../store/Action';
import HTTP from '../../script/service';
import WEBROOM from '../../store/WebRoom';
import PrettyNum from '../prettyNum/PrettyNum';
import { QRCodeCanvas } from 'qrcode.react';
import Share from '../share/Share';
import Order from './order/Order';
import FullGive from './fullGive/FullGive';
import SingerLevelTag from '../ClickToSing/components/SingerLevelTag';
import GodScoreLevelTag from '../ClickToSing/components/GodScoreLevelTag';

class DsMainNew extends PureComponent {
  state = {
    visible: false,
    ds: null, // 用户基本信息
    selCat: null, // 选中的技能
    dsShareUrl: '', // 用户主页地址
    dsShareRemake: '', // 用户主页分享语
    isVipServer: false, // 是否是VIP客服
    relationCard: null, //用户关系位
  };

  // 是否更新数据
  componentDidUpdate(prevProps, prevState, snapshot) {
    const props1 = Map.fromJS(prevProps.base.dsModal);
    const props2 = Map.fromJS(this.props.base.dsModal);

    if (!this.props.base.dsModal) {
      this.synCloseModal();
    } else if (this.props.base.dsModal && !Map.is(props1, props2)) {
      this.initDsInfoData(this.props.base.dsModal);
    }
  }

  // 获取大神信息
  initDsInfoData = (param) => {
    this.setState(
      {
        dsid: param.dsid,
        jnid: param.jnid,
        ehot: param.ehot,
        tabIndex: param.tabIndex ? param.tabIndex : 0,
        isOpen: param.isOpen,
      },
      () => {
        this.getUserDetailed();
        const { base } = this.props;
        //直接下单
        if (param.num && param.jnid && param.dsid && !param.ehot) {
          if (base.uid && base.token) {
            HTTP._is_order_plus_limit({}).then((res) => {
              if (res?.code === 200) {
                this.openOrderElement({
                  uid: param.dsid,
                  jnid: param.jnid,
                  num: param.num,
                  isEhot: false,
                  isHasGivefull: res.data,
                });
              } else {
                message.error(res?.message ?? '获取订单失败，请稍后重试~');
                this.hideModal(false);
              }
            });
          } else {
            _show_login_modal();
          }
        }
        const { dsid } = this.state;
        _get_user_affinity_info({ searchUid: dsid });
      }
    );

    if (param?.dsid) {
      _dssp_show_event({
        page_name: '我的',
        tab_name: `个人主页`,
        sub_tab_name: ``,
        scene_category: `我的`,
        scene_name: `个人主页`,
        scene_value: {
          target_uid: param.dsid,
        },
      });
    }
  };
  openOrderElement = ({ uid, jnid, num, isEhot, isHasGivefull, money }) => {
    const { base } = this.props;
    if (base.uid && base.token) {
      if (base.uid == uid) {
        message.error('你不能给自己下单');
      } else {
        this.orderElement.showModal({
          uid,
          categoryId: jnid,
          num,
          ehot: isEhot,
          hasGivefull: isHasGivefull,
          money,
        });
      }
    } else {
      _show_login_modal();
    }
  };
  // 获取用户基本信息
  getUserDetailed = () => {
    const { base } = this.props;
    const { dsid } = this.state;
    HTTP._get_v4_new_god_detailed({
      uid: dsid,
      myUid: base.uid,
      qKey: 'DsMain',
    }).then((res) => {
      if (res?.code === 200 && !!res?.data) {
        this.setState(
          {
            visible: true,
            ds: res.data,
            godCategoryList: res.data.godCategoryList,
            isVipServer: res.data?.roleId ?? false,
          },
          () => {
            const { ds } = this.state;
            //停 留3秒推荐加入聊天
            if (ds?.roomid) {
              if (WEBROOM?.roomid == ds.roomid) {
                // 已经在大神所在的房间了
                clearTimeout(this.joinTimeout);
              } else {
                this.joinTimeout = setTimeout(() => {
                  this.joinTalkElement.showModal();
                }, 3000);
              }
            }
          }
        );
        //获取礼物墙
        if (this.state.tabIndex == 2) {
          // this.getMedalInfo();
        } else if (this.state.tabIndex == 1) {
          // this.getUserGiftWall(true);
        }
      } else {
        res?.code !== 401 &&
          message.error(res?.message ?? '获取用户信息失败，请稍后重试~');
        this.hideModal(false);
      }
    });

    //用户关系位
    HTTP._get_user_relation_cards({
      searchUid: this.state.dsid,
    }).then((res) => {
      if (res?.code === 200) {
        this.setState({
          relationCard: Object.keys(res.data).length > 0 ? res.data : null,
        });
      }
    });
  };

  // 关闭窗口
  hideModal = () => {
    _dssp_send_click(73, { dsid: this.state.dsid });

    this.setState({
      visible: false,
      ds: null,
      tabIndex: 0,
      hasGivefull: false,
    });
    if (this.joinTimeout) {
      clearTimeout(this.joinTimeout);
      this.joinTimeout = null;
    }
    // 销毁主页特效，进场秀
    this.dsUserBasicInfoRef?.destroyPlay?.();

    // 停止播放声音
    this.dsUserSkillInfoRef?.stopAudio?.()

    _change_ds_modal(null);
  };

  //进入直播间
  inRoom = (e, roomid, roomname, uid) => {
    e.stopPropagation();
    e.preventDefault();
    if (this.props && this.props.close) {
      this.props.close();
    }
    if (uid) {
      Util.setCookie('enter_room_info', `2|${uid}`);
    }
    _new_room_window(
      { roomid: roomid, roomname: roomname },
      this.props.history,
      () => {
        this.hideModal();
      }
    );
  };
  //关注
  onFollow = () => {
    if (this.loading) return false;
    if (!this.props.base.userInfo) {
      _show_login_modal();
      return false;
    }
    let { dsid, ds } = this.state;
    if (this.props.base.uid == dsid) {
      message.warning('不能关注自己');
      return false;
    }
    this.loading = true;
    HTTP._add_follow_user({
      uid: this.props.base.uid,
      otherUid: dsid,
    }).then((res) => {
      this.loading = false;
      if (res.code == 200) {
        ds.ifFollow = 1;
        _dssp_send_click(76, {
          to: dsid,
        });
        this.setState({
          ds: { ...ds },
        });
      } else {
        message.error(res.message);
      }
    });
  };
  //修改备注
  onChangeRemarkName = (e) => {
    let { ds } = this.state;
    _change_remark_modal({
      show: true,
      uid: ds.uid,
      nickName: ds?.nickName || '',
      remarkName: ds?.friendRemark || '',
      callback: (remarkName) => {
        ds.friendRemark = remarkName;
        this.setState({ ds: { ...ds } });
      },
    });
  };
  //取消关注
  cancelFollow = () => {
    if (!this.props.base.userInfo) {
      _show_login_modal();
      return false;
    }
    if (this.loading) return false;
    this.loading = true;
    let { dsid, ds } = this.state;
    HTTP._cancel_follow_user({
      uid: this.props.base.uid,
      otherUid: dsid,
    }).then((res) => {
      this.loading = false;
      if (res.code == 200) {
        _dssp_send_click(77, {
          to: dsid,
        });
        ds.ifFollow = 0;
        this.setState({
          ds: { ...ds },
        });
      } else {
        message.error(res.message);
      }
    });
  };
  // 打开聊天窗口
  openNimChat = () => {
    let account = Util.$analyToAccount(this.state.ds.uid);
    const { selCat } = this.state;
    let to = {
      id: `p2p-${account}`,
      scene: 'p2p',
      account: account,
      origin: 'userMain',
    };
    if (selCat?.categoryId) {
      to['jnid'] = selCat.categoryId;
    }
    // 标注
    _new_nim_window(to);
    _dssp_send_click(91, {
      to: this.state.ds.uid,
      action: 'im',
    });
  };
  //打开声鉴主页
  showFullGive = () => {
    // this.audioEnded();
    this.fullGiveElement && this.fullGiveElement.showModal(this.state.ds);
  };

  //自动关闭
  synCloseModal = () => {
    if (!this.state.visible) return false;
    this.joinTalkElement && this.joinTalkElement.hideModal();
    this.setState({ visible: false, ds: null });
    if (this.joinTimeout) {
      clearTimeout(this.joinTimeout);
      this.joinTimeout = null;
    }
  };

  // 更新用户选择的技能
  updateSelectCategory = (category, ehot = false) => {
    const dsShareUrl = `${window.location.origin}/index?dsid=${category.uid}&jnid=${category.categoryId}&ehot=${ehot.toString()}`;
    this.setState({
      selCat: category,
      dsShareUrl,
      dsShareRemake: category.categoryName,
    });
  };

  getMicBorder = () => {
    const { ds } = this.state;
    if (!ds) {
      return null;
    }
    let icon = null;
    if (ds?.micShow?.pic) {
      icon = ds.micShow.pic['1'];
    }
    return icon ? (
      <span
        className="mic-border"
        style={{ backgroundImage: `url(${Util.transImgUrl(icon)})` }}
      />
    ) : null;
  };

  // 用户在线状态
  renderUserOnlineStatus = () => {
    const { ds } = this.state;
    if (ds?.roomName) {
      return (
        <div
          className="user-status-tag inroom"
          onClick={(e) => this.inRoom(e, ds.roomid, ds.roomName, ds.uid)}
        >
          <span className="icon-audio" />
          <span>我在 {ds.roomName} 直播间语聊中 点击进入</span>
          <span className="icon-goto" />
        </div>
      );
    }
    if (ds?.ifOnline !== 0) {
      return <div className="user-status-tag online">在线</div>;
    } else {
      return (
        <div className="user-status-tag not-online">
          {Util.transDate(ds.lastLoginTime)}
        </div>
      );
    }
  };

  render() {
    const { base } = this.props;
    const { rootConfig, channelId } = base;
    const {
      visible,
      ds,
      selCat,
      dsShareUrl,
      dsShareRemake,
      isVipServer,
      relationCard,
    } = this.state;
    return (
      <>
        <Modal
          open={visible}
          wrapClassName="iframe-body"
          centered={true}
          closable={false}
          footer={null}
          keyboard={false}
          maskClosable={false}
          focusTriggerAfterClose={false}
          zIndex={1000}
          width="1250px"
          height="720px"
        >
          {!!ds && (
            <div className="ds-main-modal">
              <div className="ds-main-header">
                <span className="window-action-inpage" onClick={this.hideModal}>
                  <CloseOutlined />
                </span>
                <div className="user-avatar">
                  <img
                    src={Util.transImgUrl(ds?.headPic ?? null, '70x70')}
                    alt={ds.nickName}
                  />
                  {this.getMicBorder()}
                </div>
                <div className="user-info">
                  <div className="user-line">
                    {ds.friendRemark && ds.friendRemark !== '' ? (
                      <h4 className="user-nick">
                        {ds.friendRemark}({ds.nickName})
                      </h4>
                    ) : (
                      <h4 className="user-nick">{ds.nickName}</h4>
                    )}
                    {this.renderUserOnlineStatus()}
                  </div>
                  <div className="user-line">
                    <div className="user-account">
                      <PrettyNum uid={ds.uid} num={ds?.beautifulNo} />
                      <span
                        className="copy-text"
                        onClick={() =>
                          Util.copyLink(
                            ds?.beautifulNo ? ds?.beautifulNo : ds.uid
                          )
                        }
                      >
                        {/*复制*/}
                      </span>
                    </div>
                    <div className="user-divider" />
                    <div className="user-level">
                      <span className="text">等级:</span>
                      {ds?.wealthHide != 1 && (
                        <i className={`icon-wealth v_${ds.wealthLevel}`} />
                      )}
                      {ds?.charmHide != 1 && (
                        <i className={`icon-charm v_${ds.glamourLevel}`} />
                      )}
                      <i className={`icon-sea v_${ds?.nobleLevel ?? 0}`} />
                      <b className="fg" />
                    </div>
                    <div className="user-divider" />
                    <div className="user-fans">粉丝数: {ds?.fansNum ?? 0}</div>
                    <div className="user-divider" />
                    <div className="user-addr">
                      IP归属地: {!!ds?.sourcePlace ? ds.sourcePlace : '未知'}
                      <Tooltip
                        classNames={{ root: 'ip-addr-tip' }}
                        placement="bottom"
                        title={
                          <>
                            <h5 className="sub-title">IP属地说明</h5>
                            <p className="sub-desc">
                              为维护网络安全、保障良好生态和社区的真实性，根据网络运营商数据、展示用户IP属地信息。
                            </p>
                          </>
                        }
                      >
                        <i className="icon-tip" />
                      </Tooltip>
                    </div>
                  </div>
                  <div className="user-line">
                    <ul className="user-tag">
                      {/* 动态标签 */}
                      {!!ds?.categoryLabel && (
                        <div className="ext-box">
                          <SingerLevelTag
                            level={ds.categoryLabel}
                            width={76}
                            height={22}
                          />
                        </div>
                      )}
                      {/* 大神分标签 */}
                      {!!ds?.godScoreLabel && (
                        <div className="ext-box">
                          <GodScoreLevelTag
                            pic={ds.godScoreLabel}
                            width={76}
                            height={22}
                          />
                        </div>
                      )}
                      {/* 声鉴音质标签 */}
                      {!!ds?.mainTimbreJson && ds.mainTimbreJson.length > 0 && (
                        <div className="ext-box">
                          <span
                            onClick={this.showFullGive}
                            className="ico timbre"
                          >
                            {ds.mainTimbreJson[0].label}
                          </span>
                        </div>
                      )}
                      {/* 技术大神标签 */}
                      {!!ds?.skillLevel && (
                        <div className="ext-box">
                          <span className="icon-jsds">{/*技术大神*/}</span>
                        </div>
                      )}
                      {/* 年龄标签 */}
                      {ds?.age != null && (
                        <div className="ext-box">
                          <span
                            className={
                              'icon-age ' + (ds.sex == 1 ? 'woman' : 'man')
                            }
                          >
                            {ds.age}
                          </span>
                        </div>
                      )}
                    </ul>
                  </div>
                </div>
                <div className="user-operation">
                  {/* 下载APP */}
                  <Popover
                    rootClassName="daidai-popover-default"
                    trigger="hover"
                    placement="bottom"
                    content={
                      <div className="app-code">
                        <QRCodeCanvas
                          value={`${rootConfig.mobilePath}?channelId=${channelId}`}
                          imageSettings={{
                            src: `/assets/img/logo-100.png`,
                            width: 30,
                            height: 30,
                          }}
                          size={100}
                          bgColor={'#FFFFFF'}
                          fgColor={'#000000'}
                          level="M"
                        />
                      </div>
                    }
                  >
                    <div className="icon-download" />
                  </Popover>
                  {/* 分享 */}
                  {!isVipServer && ds && selCat && (
                    <Popover
                      rootClassName="daidai-popover-default"
                      trigger="click"
                      placement="bottom"
                      content={
                        <Share
                          url={dsShareUrl}
                          dsid={ds.uid}
                          pic={Util.transImgUrl(ds.headPic, '200x200')}
                          remark={dsShareRemake}
                        />
                      }
                    >
                      <div className="icon-share" />
                    </Popover>
                  )}
                  {!isVipServer && ds.ifFollow && ds.ifFans ? (
                    <div
                      className="set-remark"
                      onClick={() => this.onChangeRemarkName()}
                    >
                      <i className="icon-edit"></i>设置备注
                    </div>
                  ) : null}
                  {/* 关注/取消关注 */}
                  {!isVipServer &&
                    (ds.ifFollow ? (
                      <div
                        className="icon-un-follow"
                        onClick={this.cancelFollow}
                      />
                    ) : (
                      <div className="icon-follow" onClick={this.onFollow} />
                    ))}
                  {/* 聊一聊 */}
                  {!isVipServer && (
                    <div className="icon-chat" onClick={this.openNimChat} />
                  )}
                </div>
              </div>
              <div className="ds-main-bottom-divider" />
              <div className="ds-main-center">
                <DsUserBasicInfo
                  wrappedComponentRef={el => this.dsUserBasicInfoRef = el}
                  ds={ds}
                  relationCard={relationCard}
                />
                <div className="ds-center-right">
                  <DsUserSkillInfo
                    {...this.state}
                    wrappedComponentRef={el => this.dsUserSkillInfoRef = el}
                    updateSelectCategory={this.updateSelectCategory}
                    openNimChat={this.openNimChat}
                    openOrderElement={this.openOrderElement}
                    close={this.hideModal}
                    openUserInfo={this.initDsInfoData}
                    inRoom={this.inRoom}
                  />
                  <div className="ds-main-bottom-divider" />
                  <DsUserAchieve ds={ds} {...this.state} />
                </div>
              </div>

              {/* 主页特效容器 */}
              <div id="ds-index-effects-content" />
              {/* 座驾特效 */}
              <div id="ds-car-effects-content" />
            </div>
          )}
        </Modal>
        {/* 直播间弹窗 */}
        <JoinTalk
          wrappedComponentRef={(el) => (this.joinTalkElement = el)}
          base={base}
          ds={ds}
        />
        {/* 下单 */}
        <Order
          wrappedComponentRef={(el) => (this.orderElement = el)}
          base={base}
          openNimChat={this.openNimChat}
        />
        {/* 声鉴 */}
        <FullGive
          wrappedComponentRef={(el) => (this.fullGiveElement = el)}
          base={base}
        />
      </>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(DsMainNew, { withRef: true })
);
